import {ReactNode} from 'react';
import Icon from '../Icon';
import {IconName} from '../../icons/paths';

// The dashed card: an icon tile, a title, a line or two, and maybe one thing to do.
type Props = {
    icon: IconName;
    title: ReactNode;
    children?: ReactNode;
    action?: ReactNode;
    tone?: 'grow' | 'plain';
    className?: string;
};

export default function EmptyState({icon, title, children, action, tone = 'grow', className = ''}: Props) {
    const tile = tone === 'grow' ? 'bg-kind-grow-bg text-kind-grow-fg' : 'bg-kind-plain-bg text-kind-plain-fg';
    return (
        <section className={`flex flex-col items-start gap-3 rounded-[18px] border-[1.5px] border-dashed border-line p-5 ${className}`}>
            <span className={`flex h-12 w-12 items-center justify-center rounded-[14px] ${tile}`}>
                <Icon name={icon} size={26} />
            </span>
            <h2 className="m-0 text-lg">{title}</h2>
            {children && <div className="text-ink-2">{children}</div>}
            {action}
        </section>
    );
}
